import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Heading, Container, Flex } from '@magicsoup.io/stock'

import { Query } from 'react-apollo'
import gql from 'graphql-tag'


import {
  Section,
  P,
} from '../../styled'

const getRandomInt = (min, max) => (Math.floor(Math.random() * (max - min + 1)) + min);

class Stats extends React.Component {

  countUp(value) {
    getRandomInt(0,value)
  }

  render() {
    return(
      <StaticQuery
      query={graphql`
        query statsQuery {
          generalJson {
            activity {
              headline
              activeMissions {
                title
                content
              }
              activeAgents {
                title
                content
              }
              completedMissions {
                title
                content
              }
            }
          }
        }
      `}
      render={staticData => (
        <Query query={StatsQuery}>
          {({
            loading, error, data
          }) => {
            if (loading) return "loading"
            if (error) return error.message
            
            const { isVisible } = this.props
            return (
              <Section py="5">
                <Heading as="h1" textAlign="center">{staticData.generalJson.activity.headline}</Heading>
                <Container>
                  <Flex flexWrap="wrap" py={[4]}>
                    <Flex width={[1,1,1/3]} flexDirection="column" alignItems="center" justifyContent="center">
                      <Heading as="h1" variant="counter" fontSize={[7]} m={[0]}>{data.stats.activeMissionCount}</Heading>
                      <Heading as="h2">{staticData.generalJson.activity.activeMissions.title}</Heading>
                      <P textAlign="center" px={[5]}>{staticData.generalJson.activity.activeMissions.content}</P>
                    </Flex>
                    <Flex width={[1,1,1/3]} flexDirection="column" alignItems="center" justifyContent="center">
                      <Heading as="h1" variant="counter" fontSize={[7]} m={[0]}>{data.stats.userCount}</Heading>
                      <Heading as="h2">{staticData.generalJson.activity.activeAgents.title}</Heading>
                      <P textAlign="center" px={[5]}>{staticData.generalJson.activity.activeAgents.content}</P>
                    </Flex>
                    <Flex width={[1,1,1/3]} flexDirection="column" alignItems="center" justifyContent="center">
                      <Heading as="h1" variant="counter" fontSize={[7]} m={[0]}>{data.stats.completedMissionCount}</Heading>
                      <Heading as="h2">{staticData.generalJson.activity.completedMissions.title}</Heading>
                      <P textAlign="center" px={[5]}>{staticData.generalJson.activity.completedMissions.content}</P>
                    </Flex>
                  </Flex>
                </Container>
              </Section>
            )}}
        </Query>
      )} 
      />
    )
  }
}




const StatsQuery = gql`
    {
      stats {
        completedMissionCount
        activeMissionCount
        userCount
    }
  }
`

export default Stats
